export default {
  title: "",
  subtitle: "Chilean Companies Resgitration",
  path: "company_registration_cl",
  paragraphs: [
    "In Chile the document_type is going to be “rut” (a 9-digit). Below you can check a payload with initial required information. For other requirements depending on payment methods, check the table in section 'Information needed for registration (Companies)'"
  ],
  request: {
    payload: {
      "company": { 
        "document_number": "265874694", 
        "document_type": "rut", 
        "social_name": "Company's name", 
        "fiscal_country": "Chile" 
      }
    },
    responses: {
      "data": {
        "updated_at": "2025-05-02T22:11:08.714019",
        "status": "approved",
        "social_name": "Company's name",
        "required_clearance_level": 1,
        "references": [],
        "phone_number": null,
        "partners": [],
        "net_value": null,
        "net_monthly_average_income": null,
        "main_activity": null,
        "inserted_at": "2025-05-02T22:11:08.672280",
        "id": "01cf5b70-569f-43f5-80a4-7af303c9c003",
        "fiscal_country": "Chile",
        "email": null,
        "documents": [],
        "document_type": "rut",
        "document_number": "265874694",
        "creation_date": null,
        "company_type": null,
        "company_name": null,
        "clearance_level": 1,
        "address_street": null,
        "address_state": null,
        "address_postal_code": null,
        "address_number": null,
        "address_neighborhood": null,
        "address_country": null,
        "address_complement": null,
        "address_city": null,
        "activity_type": null
      }
    }
  },
  parameterPayload: [
    {
      name: "company",
      type: "object",
      required: true,
      description: "An object containing:",
      is_parent: true
    },{
      name: "company.document_number",
      type: "string",
      required: true,
      description: "Company's Document number",
    },{
      name: "company.document_type",
      type: "string",
      required: true,
      description: "Must be rut",
    },{
      name: "company.social_name",
      type: "string",
      required: true,
      description: "Company's name",
    },{
      name: "company.fiscal_country",
      type: "string",
      required: true,
      description: "Chile",
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectCompanies/CompaniesRegistrationCL.js